const homepage = {
    title: 'Pagina Principal',
    welcome: 'Bemvindo no Protein Zone',
}

export default homepage
